import {Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-it-asset-management-value',
    templateUrl: './it-asset-management-value.component.html',
    styleUrls: ['./it-asset-management-value.component.css']
})
export class ItAssetManagementValueComponent implements OnInit, OnDestroy {

    masterNameSelected: number;
    columnNameSelected: number;
    descriptionSelected: number;
    assetValue: string;
    clients: any[];
    clientId: number;
    masterName: string;
    columnName: string;
    description: string;
    public displayed: boolean;
    displayData: any;
    isError = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    masterNameObj = [];
    columnNameObj = [];
    descObj = [];
    fileUploadUrl: string;
    uploadButtonName = 'Upload File';
    attachment: any;
    formData: any;
    pageName: string;
    openModalButton: string;
    breadcrumb: string;
    folderName: string;
    tabName: string;
    show: boolean;
    selected: number;
    prevPath: string;
    nextPath: string;
    columnDefinitions: Column[];
    gridOptions: GridOption;
    dataset = [];
    angularGrid: AngularGridInstance;
    // totalData: number;
    selectedTitles: any[];
    gridObj: any;
    gridWidth: number;
    private notifier: NotifierService;

    assetValueObj: any = {};
    previousOffset: any;
    nextOffset: any;
    pageSize: number;
    collectionSize: any;
    offset: number;
    pageNo: any;
    totalPage: any;
    paginationType: string;
    page_no: number;
    pageSizeObj: any[];
    pageSizeSelected: number;

    private baseFlag: boolean;
    add = false;
    del = false;
    edit = false;
    view = false;
    private userAuth: Subscription;

    uploadSuccessMessage: string;
    @ViewChild('content') private content;
    private dialogRef: MatDialogRef<any, any>;
    @Input() isModifyAsset: boolean;
    @Input() ticketId: string;
    templateDownloadMessage: string;
    templatebtndisabled: boolean;


    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService, private dialog: MatDialog) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    // console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            item.createdBy = this.messageService.getUserId();
                            this._rest.editAssetManagementValue(item).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // console.log('data--Done');
                                    this.notifier.notify('success', 'Updated successfully');
                                } else {
                                    // console.log('data--Not---Done');
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteAssetManagementValue({
                                id: item.id,
                                user_id: this.messageService.getUserId()
                            }).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.totalData = this.totalData - 1;
                                    this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getUrlPath().subscribe(path => {
            // console.log('---inside base ' + JSON.stringify(path));
            this.prevPath = path.prevPath;
            this.nextPath = path.nextPath;
        });
    }

    ngOnInit() {
        this.templatebtndisabled = false;
        this.templateDownloadMessage = '';
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.pageSizeSelected = this.messageService.pageSelected;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.pageSizeObj = this.messageService.pagination;


        this.displayed = true;
        this.totalData = 0;
        this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
        this.attachment = '';
        this.displayData = {
            pageName: 'Maintain Asset Details',
            openModalButton: 'Add Digital Asset value',
            breadcrumb: 'Digital Asset value',
            folderName: 'All Digital Assetvalue',
            tabName: 'Digital Asset value'
        };
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
        // this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
        //     this.respObject = res;
        //     if (this.respObject.success) {
        //         this.clientId = this.respObject.details[0].clientId;
        //         this.formData = {
        //             'clientId': this.clientId,
        //             'createdBy': this.messageService.getUserId(),
        //             'type': 'asset'
        //         };
        //         // ======================================= get asset master data =============================================
        //         this.getAssetMasterData();
        //
        //         // ================================================================================
        //     } else {
        //         this.notifier.notify('error', this.respObject.errorMessage);
        //     }
        // }, (err) => {
        //     this.notifier.notify('error', this.messageService.SERVER_ERROR);
        // });

        this.gridOptions = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            enableCheckboxSelector: true,
            enableRowSelection: true,
        };
        this.columnDefinitions = [];
        // this.messageService.setColumnDefinitions(this.columnDefinitions);
    }

    onPageLoad() {
        this.formData = {
            'clientId': this.clientId,
            'createdBy': this.messageService.getUserId(),
            'type': 'asset'
        };
        // ======================================= get asset master data =============================================
        this.getAssetMasterData();
    }

    angularGridReady(angularGrid: AngularGridInstance) {
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
        const classes = document.getElementsByClassName('search-filter');
        for (let i = 0; i < classes.length; i++) {
            classes[i].setAttribute('placeholder', '');
        }
        this.gridObj.onBeforeEditCell.subscribe((e, args) => {
            // this.messageService.setBeforeChangeData(args);

            if (args.item.seq !== 1 && args.item.type === 'ClientTicket') {
                // console.log('invalid');
                return false;
            }
        });
    }

    getAssetMasterData() {
        this._rest.getAssetManagementMaster(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                const dataArr = this.respObject.details;
                // console.log('master data=', dataArr);
                this.masterNameObj = dataArr;
                this.masterNameObj.unshift({id: 0, masterName: 'Select asset master name'});
                this.masterNameSelected = 0;
                // this.totalData = dataArr.length;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.masterNameSelected = 0;
            this.columnNameSelected = 0;
            this.descriptionSelected = 0;
            this.assetValue = '';
            this.isError = false;

            this.columnNameObj = [];
            this.getTableData();
            // this.modalService.open(content, {}).result.then((result) => {
            // }, (reason) => {
            //
            // });
            this.dialogRef = this.dialog.open(this.content, {
                width: '500px'
            });
        }

    }

    toggleViews() {
        this.displayed = !this.displayed;
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    save() {
        // console.log('ticket id================' + this.ticketId);
        for (const i in this.columnNameObj) {
            const columnNameId = this.columnNameObj[i].columnId;
            if (this.assetValueObj[columnNameId] === undefined) {
                if (this.columnNameObj[i].validationValue) {
                    alert('Please select ' + this.columnNameObj[i].columnName);
                    return;
                }
                this.assetValueObj[columnNameId] = 'NA';
            }
        }
        const data = {
            client_id: this.clientId,
            masterId: this.masterNameSelected,
            descriptionId: this.descriptionSelected,
            ticketId: this.ticketId,
            createdBy: this.messageService.getUserId(),
            assetValues: this.assetValueObj
        };
        // console.log('asset management value insert data:' , data);
        if (!this.messageService.isBlankField(data)) {
            this._rest.addAssetManagementAllValue(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    // const id = this.respObject.details;
                    // this.messageService.setRow({
                    //   id: id, masterName: this.masterName,
                    //   columnName: this.columnName, description: this.description, assetValue: this.assetValue
                    // });
                    this.masterNameSelected = 0;
                    this.columnNameSelected = 0;
                    this.descriptionSelected = 0;
                    this.assetValue = '';
                    this.assetValueObj = {};
                    this.columnNameObj = [];
                    this.getTableData();
                    // this.getSupportGroup();
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = err;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }


    // getTableData() {
    //   // console.log(this.messageService.view)
    //   if (!this.messageService.view) {
    //     this.notifier.notify('error', 'You do not have view permission');
    //   } else {
    //     this._rest.getAssetManagementValue(this.clientId).subscribe((res) => {
    //       this.respObject = res;
    //       // console.log(this.respObject);
    //       if (this.respObject.success) {
    //         const data = this.respObject.details;
    //         console.log('value data=', data);
    //         this.totalData = data.length;
    //       } else {
    //         this.notifier.notify('error', this.respObject.errorMessage);
    //       }
    //     }, (err) => {
    //       this.notifier.notify('error', this.messageService.SERVER_ERROR);
    //     });
    //   }
    // }

    onMasterChange(value: any) {
        this.masterName = this.masterNameObj[value].masterName;
        // =================================== get column name================================

        // =============================================================================================================
        // =================================== get aset description================================
        this._rest.getNewAssetDetailsByMaster(this.clientId, this.masterNameSelected).subscribe((res) => {
            this.respObject = res;
            // console.log(this.respObject)
            if (this.respObject.success) {
                const data = this.respObject.details;
                this.descObj = data;
                this.descObj.unshift({descId: 0, description: 'Select asset ID'});
                this.totalData = data.length;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
        // =============================================================================================================
    }


    onClientChange(value: any) {
        this.columnName = this.columnNameObj[value].columnName;
    }

    onDescriptionChange(value: any) {
        //this.description = this.descObj[value].description;
        var selectedAssetID = '';
        for (let desc of this.descObj) {
            //Compare Value Only
            if (desc.descId == this.descriptionSelected) {
                selectedAssetID = desc.description;
                break;
            }
        }
        // console.log(selectedAssetID);
        // Get Column Name List
        this._rest.getAssetColumnByMasterForValue(this.clientId, this.masterNameSelected).subscribe((res) => {
            this.respObject = res;
            // console.log(this.respObject)
            if (this.respObject.success) {
                for (let detailsObj of this.respObject.details) {
                    if (detailsObj.validationValue) {
                        // console.log(detailsObj.validationValue);
                        detailsObj.validationValue = JSON.parse(detailsObj.validationValue);
                    }
                    if (detailsObj.columnName === 'Asset ID') {
                        this.assetValueObj[detailsObj.columnId] = selectedAssetID;
                    }
                }
                const data = this.respObject.details;

                this.columnNameObj = data;
                //Added by Subhasis
                //this.columnNameObj.unshift({columnId: 0, columnName: 'Select asset column name'});
                this.totalData = data.length;

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    onFileComplete(data: any) {
        if (data.success) {
            // this.attachment = data.fileName;
            alert(this.messageService.UPLOAD_MESSAGE);
            this.isError = false;
            this.getAssetMasterData();
            this.getTableData();
        } else {
            this.isError = true;
            this.errorMessage = data.errorMessage;
        }
    }

    // Added By Subhasis
    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.nextOffset = 0;
            this.previousOffset = 0;
            this.pageSize = this.messageService.pageSize;
            this.pageSizeSelected = this.messageService.pageSelected;
            this.page_no = 0;
            this.totalPage = 0;
            this.paginationType = 'next';
            this.pageSizeObj = this.messageService.pagination;
            this.nextOffset = 0;
            this.totalData = 0;
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    downloadAssetTemplate() {

        this._rest.getAssetManagementTemplate(this.clientId).subscribe((res1) => {
            this.templatebtndisabled = true;
            this.templateDownloadMessage = '<span>Please wait while generating template</span>';
            this.respObject = res1;
            if (this.respObject.success) {
                this.templatebtndisabled = false;

                this.templateDownloadMessage = '<a class=\'download-link\' target=\'blank\' href=\'' +
                    this.messageService.ASSET_REPORT_PATH + this.respObject.resVal.filename + '\'>Download</a>';
                // console.log(res1);

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
                this.templatebtndisabled = false;
                this.templateDownloadMessage = '';
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
            this.templatebtndisabled = false;
            this.templateDownloadMessage = '';
        });
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this._rest.getAssetManagementDataTable(this.clientId, this.masterNameSelected, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        //console.log(respObject);
        if (respObject.success) {
            if (respObject.details.columnObj.length == 0) {
                this.columnDefinitions = [];
                this.dataset = [];
            } else {
                if (offset === 0) {
                    this.totalData = respObject.details.totalData[0].count;
                    this.totalPage = respObject.details.totalPage;
                    if (this.totalPage === 0) {
                        this.totalPage = 1;
                    }
                }
                if (!this.isEmpty(respObject.details.dataObj)) {
                    const data = respObject.details.dataObj;
                    // console.log(data);
                    const columnNameObj = this.respObject.details.columnObj;
                    // console.log(columnNameObj);
                    this.columnDefinitions = [{id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true, minWidth: 60}];
                    // {id: 'description', name: 'descriptionId', field: 'description', sortable: true, filterable: true, minWidth: 60}];
                    for (let i = 0; i < columnNameObj.length; i++) {
                        this.columnDefinitions.push({
                            id: columnNameObj[i].columnName,
                            name: columnNameObj[i].columnName,
                            field: columnNameObj[i].id,
                            sortable: true,
                            filterable: true,
                            minWidth: 100
                        });
                    }
                    this.nextOffset = respObject.details.nextOffset;
                    this.offset = respObject.details.nextOffset;
                    this.previousOffset = respObject.details.previousOffset;
                    this.messageService.setTotalData(this.totalData);
                    //this.totalPage = this.totalData;
                    const colval = [];
                    for (let j = 0; j < data.length; j++) {
                        const columVal = data[j].columVal;
                        const descId = data[j].id;
                        const description = data[j].description;
                        const columnValue = columVal.split(',');
                        // console.log('column=', JSON.stringify(columnValue));
                        const jsonval = {};
                        jsonval['id'] = descId;
                        jsonval['description'] = description;
                        for (let k = 0; k < columnValue.length; k++) {
                            const attrVal = columnValue[k];
                            const attrValue = attrVal.split(':');
                            jsonval[attrValue[0]] = attrValue[1];
                        }
                        colval.push(jsonval);
                    }
                    // console.log(colval);
                    this.dataset = colval;
                    //this.messageService.setGridData(data);
                    // ----------------------------------------------
                    if (offset !== 0) {
                        const totalCount = this.totalData;
                        const divRes = totalCount / this.pageSize;
                        const remainder = totalCount % this.pageSize;
                        if (remainder === 0) {
                            this.totalPage = parseInt(String(divRes), 10);
                        } else {
                            this.totalPage = parseInt(String(divRes), 10) + 1;
                        }
                    }
                    // ------------------------------------------------
                    if (paginationType === 'next') {
                        this.page_no = this.page_no + 1;
                    } else if (paginationType === 'prev') {
                        this.page_no = this.page_no - 1;
                    } else if (paginationType === '' && this.page_no === 0) {
                        this.page_no = this.page_no + 1;
                    }
                    if (this.totalData <= this.pageSize * this.page_no) {
                        this.nextOffset = 0;
                    }
                } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                    this.nextOffset = 0;
                } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                    this.previousOffset = 0;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }

            }

        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        // console.log(this.pageSizeObj[value].value);
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = this.pageSizeObj[value].value;
        ;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    getNextData() {
        this.getData({'offset': this.nextOffset, 'paginationType': 'next'});
    }

    getPreviousData() {
        this.getData({'offset': this.previousOffset, 'paginationType': 'prev'});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

    close() {
        this.dialogRef.close();
    }
}
